export default __webpack_public_path__ + "static/media/birdUp.fae2933a.svg";